export const GIG_CARDS_LAZY_OFFSET = 8,
    GIG_CARDS_MOBILE_LAZY_OFFSET = 4,
    LIST_VIEW_CARDS_LAZY_OFFSET = 8,
    LISTINGS_DESKTOP_SIZE = 48;

// SSR'd card count on SC/NSC, behind CROWS_SSR_GIG_COUNT - independent of the *_LAZY_OFFSET eager-image knobs above.
export const SSR_GIG_COUNT_DESKTOP = 24,
    SSR_GIG_COUNT_MOBILE = 12,
    SSR_GIG_COUNT_AI_CRAWLER = 48;

export const LOGO_MAKER_BANNER_ROW = {
    DESKTOP: 5,
    TABLET: 4,
    MOBILE: 5,
};
